var _excluded = ["results", "loadMore", "currentPage", "lastPage", "height", "title"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { instance } from '@semantic-ui-react/event-stack';
import InfiniteScroll from 'react-infinite-scroller';
import { Accordion, Container, Header, Icon, List, Ref, Transition } from 'semantic-ui-react';
import { CollectionList, CollectionListItem } from "../CollectionList";

/**
 * CollectionTreeItem
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CollectionTreeItem = function CollectionTreeItem(props) {
  var item = props.item,
    active = props.active,
    onItemCreate = props.onItemCreate;
  var results = item.results,
    loadMore = item.loadMore,
    currentPage = item.currentPage,
    lastPage = item.lastPage,
    height = item.height,
    title = item.title,
    rest = _objectWithoutPropertiesLoose(item, _excluded);
  var _useState = useState(window.innerWidth),
    width = _useState[0],
    setWidth = _useState[1];
  var _useState2 = useState(active),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var functionnalRef = /*#__PURE__*/React.createRef();
  var frameId;
  var update = useCallback(function () {
    if (!_.isNil(functionnalRef) && !_.isNil(functionnalRef.current) && !_.isNil(functionnalRef.current.firstChild) && !_.isNil(functionnalRef.current.firstChild.getBoundingClientRect())) {
      setWidth(functionnalRef.current.firstChild.getBoundingClientRect().width);
    }
  }, [functionnalRef]);
  var handleResize = function handleResize() {
    frameId = requestAnimationFrame(update);
  };
  useEffect(function () {
    instance.sub('resize', handleResize, {
      target: 'window'
    });
    return function () {
      instance.unsub('resize', handleResize, {
        target: 'window'
      });
      cancelAnimationFrame(frameId);
    };
  });
  useEffect(function () {
    update();
  }, [functionnalRef, active, update]);
  var handleItemCreate = useCallback(function (event) {
    _.invoke(props, 'onItemCreate', event, title);
  }, [title, props]);
  var contentItem = React.useMemo(function () {
    return /*#__PURE__*/_jsxs(Accordion.Content, {
      active: true,
      children: [/*#__PURE__*/_jsx(Container, {
        fluid: true,
        style: {
          height: height,
          overflowY: 'auto'
        },
        children: /*#__PURE__*/_jsx(InfiniteScroll, {
          pageStart: 0,
          loadMore: loadMore,
          hasMore: currentPage < lastPage,
          useWindow: false,
          children: /*#__PURE__*/_jsx(Ref, {
            innerRef: functionnalRef,
            children: /*#__PURE__*/_jsx(CollectionList, Object.assign({}, rest, {
              items: results
            }))
          })
        })
      }), onItemCreate && onItemCreate !== null && /*#__PURE__*/_jsx(Container, {
        fluid: true,
        children: /*#__PURE__*/_jsx(List, {
          celled: true,
          inverted: true,
          selection: true,
          children: /*#__PURE__*/_jsx(CollectionListItem, {
            onClick: handleItemCreate,
            size: "mini",
            style: {
              width: width
            },
            children: /*#__PURE__*/_jsx(Container, {
              textAlign: "center",
              fluid: true,
              children: /*#__PURE__*/_jsx(Icon, {
                name: "add",
                circular: true
              })
            })
          })
        })
      })]
    });
  }, [currentPage, functionnalRef, handleItemCreate, height, lastPage, loadMore, rest, results, width, onItemCreate]);
  var noResultContent = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Accordion.Content, {
      active: true,
      children: onItemCreate && onItemCreate !== null && /*#__PURE__*/_jsx(Ref, {
        innerRef: functionnalRef,
        children: /*#__PURE__*/_jsx(Container, {
          fluid: true,
          children: /*#__PURE__*/_jsx(List, {
            celled: true,
            inverted: true,
            selection: true,
            children: /*#__PURE__*/_jsx(CollectionListItem, {
              onClick: handleItemCreate,
              size: "mini",
              style: {
                width: width
              },
              children: /*#__PURE__*/_jsx(Container, {
                textAlign: "center",
                fluid: true,
                children: /*#__PURE__*/_jsx(Icon, {
                  name: "add",
                  circular: true
                })
              })
            })
          })
        })
      })
    });
  }, [functionnalRef, handleItemCreate, width, onItemCreate]);
  var handleHide = React.useCallback(function () {
    setVisible(false);
  }, []);
  var handleShow = React.useCallback(function () {
    if (!visible) {
      setVisible(true);
    }
  }, [visible]);
  var transitionItem = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Transition, {
      visible: active,
      onHide: handleHide,
      onStart: handleShow,
      children: visible ? !_.isEmpty(results) ? contentItem : noResultContent : /*#__PURE__*/_jsx("div", {})
    });
  }, [active, contentItem, handleHide, handleShow, noResultContent, results, visible]);
  return React.useMemo(function () {
    var handleAccordionClick = function handleAccordionClick() {
      var index = props.index;
      _.invoke(props, 'onClick', index);
    };
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Accordion.Title, {
        content: /*#__PURE__*/_jsx(Header, {
          as: "h4",
          style: {
            display: 'inline'
          },
          children: title
        }),
        active: active,
        onClick: handleAccordionClick
      }), transitionItem]
    });
  }, [title, active, transitionItem, props]);
};
CollectionTreeItem.handledProps = ["active", "index", "item", "onClick", "onItemCreate"];
CollectionTreeItem.propTypes = {
  /** Item. */
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object,
  /** Active. */
  active: PropTypes.bool,
  /** Function on click accordion title. */
  onClick: PropTypes.func,
  /** Index in the tree. */
  index: PropTypes.number,
  /** Func on item create. */
  onItemCreate: PropTypes.func
};
export default CollectionTreeItem;